module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/zeroHeroesNoPPAPresents-0c4dea8bec4882f7565c876cd4671996.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/zeroHeroesNoPPAPresents.png
// module id = 2510
// module chunks = 2